@if (isEditing()) {
    <div class="flex flex-col gap-medpace-field">
        <mds-text-field
            id="line1"
            [formCtrl]="addressFormGroup.controls.line1Control"
            placeholder="Type here..."
            appearance="outline"
            inputType="text"
            label="Address Line 1"
            width="100%"
            [required]="true"
            (input)="emitStringChange($event, { id: 'line1' })"
            appGoogleMapsAutocomplete
            (placeChangeEvent)="googleMapsAutocompletePlaceChange($event)"
        ></mds-text-field>

        <mds-text-field
            id="line2"
            [formCtrl]="addressFormGroup.controls.line2Control"
            placeholder="Type here..."
            appearance="outline"
            inputType="text"
            label="Address Line 2"
            width="100%"
            (input)="emitStringChange($event, { id: 'line2' })"
        ></mds-text-field>

        <mds-text-field
            id="city"
            [formCtrl]="addressFormGroup.controls.cityControl"
            placeholder="Type here..."
            appearance="outline"
            inputType="text"
            label="City"
            width="100%"
            [required]="true"
            (input)="emitStringChange($event, { id: 'city' })"
        ></mds-text-field>

        <div class="grid grid-cols-2 gap-medpace-field">
            <mds-text-field
                id="stateOrProvince"
                [formCtrl]="addressFormGroup.controls.stateOrProvinceControl"
                placeholder="Type here..."
                appearance="outline"
                inputType="text"
                [label]="regionStateType$ | async"
                width="100%"
                (input)="emitStringChange($event, { id: 'stateOrProvince' })"
            ></mds-text-field>

            <mds-text-field
                id="postalCode"
                [formCtrl]="addressFormGroup.controls.postalCodeControl"
                placeholder="Type here..."
                appearance="outline"
                inputType="text"
                label="Zipcode/Postal Code"
                width="100%"
                [required]="true"
                (input)="emitStringChange($event, { id: 'postalCode' })"
            ></mds-text-field>
        </div>

        <mds-dropdown
            [closeOnPageScroll]="false"
            [formCtrl]="addressFormGroup.controls.regionControl"
            appearance="outline"
            label="Region"
            placeholder="Select region"
            [options]="regions"
            id="regionDropdown"
            [required]="true"
            (selectionChange)="emitChange($event.value, { id: 'region' })"
        ></mds-dropdown>

        <mds-autocomplete
            [closeOnPageScroll]="false"
            [options]="countries$ | async"
            appearance="outline"
            placeholder="Enter country"
            label="Country"
            id="countryAutocomplete"
            inputType="text"
            [formCtrl]="addressFormGroup.controls.countryControl"
            [validateInput]="true"
        >
        </mds-autocomplete>
    </div>
}

@if (!isEditing() && !loaderSpinner) {
    @let site = site$ | async;
    <div class="flex flex-col gap-medpace">
        <div>
            <h5>Address Line 1</h5>
            <span>{{ site?.address?.line1 }}</span>
        </div>

        @if (site?.address?.line2) {
            <div>
                <h5>Address Line 2</h5>
                <span>{{ site?.address?.line2 }}</span>
            </div>
        }

        <div class="grid grid-cols-3 gap-medpace">
            <div>
                <h5>City</h5>
                <span>{{ site?.address?.city }}</span>
            </div>
            <div>
                <h5>{{ regionStateType$ | async }}</h5>
                <span>{{ site?.address?.stateOrProvince }}</span>
            </div>
            <div>
                <h5>Zipcode/Postal Code</h5>
                <span>{{ site?.address?.postalCode ? site?.address?.postalCode : 'Unspecified' }}</span>
            </div>
        </div>
        <div class="grid grid-cols-3 gap-medpace">
            <div>
                <h5>Region</h5>
                <span>{{ site?.address?.region }}</span>
            </div>
            <div>
                <h5>Country</h5>
                <span>{{ site?.address?.country }}</span>
            </div>
        </div>
    </div>
}

@if (!isEditing() && loaderSpinner) {
    <medpace-loading-card></medpace-loading-card>
}
